import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import AI from '../views/AI.vue';
import Courses from '../views/Courses.vue';
import English from '../views/English.vue';
import Contact from '../views/Contact.vue';
import ITServices from '../views/Consulting.vue';
import Consulting from '../views/Consulting.vue';

const routes = [
	{ path: '/', name: 'Home', component: Home, meta: { title: 'd4quality | Strona główna' } },
	{ path: '/ai', name: 'AI', component: AI, meta: { title: 'd4quality | Sztuczna Inteligencja' } },
	{ path: '/consulting', name: 'Consulting', component: Consulting, meta: { title: 'd4quality | Konsulting AI' } },
	{ path: '/courses', name: 'Courses', component: Courses, meta: { title: 'd4quality | Szkolenia AI' } },
	{ path: '/it-services', name: 'ITServices', component: ITServices, meta: { title: 'd4quality | Usługi IT' } },
	{ path: '/english', name: 'English', component: English, meta: { title: 'd4quality | Język Angielski' } },
	{ path: '/contact', name: 'Contact', component: Contact, meta: { title: 'd4quality | Kontakt' } },
	{ path: '/privacy-policy', name: 'PrivacyPolicy', component: () => import('../views/PrivacyPolicy.vue'), meta: { title: 'd4quality | Polityka Prywatności' } },
	{
		path: '/courses/:slug',
		name: 'CourseDetail',
		component: () => import('@/views/CourseDetail.vue'),
	},
	

];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

// Ustawianie dynamicznego tytułu po każdej zmianie trasy
router.afterEach((to) => {
	// Ustawiamy tytuł strony na podstawie meta.title z trasy
	// Jeśli meta.title nie istnieje, domyślnie ustawiamy "d4quality"
	document.title = to.meta.title || 'd4quality';
});

export default router;